import React from 'react';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';

const UPTenantSupportCard = () => {
  return (
    <SrCard margin="0" maxWidth="375px" padding="27px 20px">
      <SrBox display="flex" flexDirection="column">
        <SrText font="greycliff" fontSize="24px" weight="800" display="block">
          Tenant Support? Covered.
        </SrText>
        <SrText font="greycliff" fontSize="14px" weight="400" display="block" marginTop="4px">
          We help your tenants with all things utility setup.
        </SrText>
        <SrBox marginTop="8px" width="100%">
          <SrText font="greycliff" fontSize="16px" weight="800" display="block">
            Tenant Support: (737) 377-1570
          </SrText>
          <SrText font="greycliff" fontSize="14px" weight="400" display="block" fontStyle="italic">
            Available Every Day, 8 AM–8 PM CT
          </SrText>
        </SrBox>
      </SrBox>
    </SrCard>
  );
};

export default UPTenantSupportCard;
